import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICreatePermissoes, IUpdatePermissoes } from './permissao.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PermissaoService {
  constructor(private http: HttpClient) {}

  public CreatePermissoes(body: ICreatePermissoes | any, guid: string): Observable<any> {
    const headers = new HttpHeaders({
              IdempotencyKey: guid
            });
            
    return this.http.post<any>(
      `${environment.baseURL}Permissao/CreatePermissoes`,
      body,
      { headers: headers }
    );
  }

  public GetPermissoes(FK_PERF?: number): Observable<any> {
    return this.http.get<any>(
      `${environment.baseURL}Permissao/GetPermissoes?FK_PERF=${FK_PERF}`
    );
  }

  public GetPermissoesByFuncionario(FK_FUNC: number): Observable<any> {
    return this.http.get<any>(
      `${environment.baseURL}Permissao/GetPermissoes?FK_FUNC=${FK_FUNC}`
    );
  }

  public UpdatePermissoes(body: IUpdatePermissoes | any): Observable<any> {
    return this.http.put<any>(
      `${environment.baseURL}Permissao/UpdatePermissoes`,
      body
    );
  }
}
